import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import common from '@/assets/js/common.js'
import achievement from '@/routers/achievement'//成果中心
import supermarket from '@/routers/supermarket'//科技mall
import school from '@/routers/school'//科创培训
import investment from '@/routers/investment'//园区
import purchase from '@/routers/purchase'//拼购
import garden_activity from '@/routers/garden_activity'//园区活动
import policy_info from '@/routers/policy_info'//政策信息
import account from '@/routers/account'//登录注册等
import personal_center from '@/routers/personal_center'//个人中心
import search_result from '@/routers/search_result'//搜索结果
import about_us from '@/routers/about_us'//关于我们
import eight_min from '@/routers/eight_min'//8分钟路演
const home = [{
  path: '/home',
  name: 'home',
  meta: {
    exp: '首页',
    requireAuth: false
  },
  component: () => import('@/views/home/index.vue'),
}]
let indexRouter = new Set([...home, ...investment, ...garden_activity, ...policy_info, ...about_us, ...purchase,...search_result,...achievement,...supermarket,...school,...eight_min]);//主菜单页面
let _routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    meta: {
      exp: '首页',
      requireAuth: false
    },
    redirect: '/home',
    component: () => import('@/views/index.vue'),
    children: indexRouter
  },
  {
    path: '*',
    component: () => import('@/views/p404/p404.vue')
  },
]
let routes = new Set([..._routes, ...account, ...personal_center]);

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

let routerFiltration = ['/qq_login', '/wx_login', '/bind_account', '/register', '/forget_password']
// 立个flag，标识是不是第一次路由
let flag = true;
//路由拦截器
// to: Route: 即将要进入的目标 路由对象
//from: Route: 当前导航正要离开的路由
router.beforeEach((to, from, next) => {
  function routerSettings(){
    const title = to.meta && to.meta.exp;
    // if (title) {
    //   document.title = title;
    // }
    //根据字段判断是否路由过滤
    let matched = to.matched.some((item) => {
      return item.meta.requireAuth;
    });
    to.query.timestamp = new Date().getTime(); // 每次路由都加上参数，确保每次路由都能被拦截
    if (to.path === from.path && Object.keys(to.query).length === 1 && !flag) { // 路由地址一样，参数等于1，也就是默认参数，不是第一次路由
      store.dispatch('setIsRouterAlive', false); // 设置isRouterAlive为false隐藏App.vue router-view
      next();
    } else if (matched) { // 判断该路由是否需要登录权限
      if (sessionStorage.getItem('token')) { //身份信息获取
        next();
      } else {
        next({
          path: '/login',
          query: { redirect: to.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
      }
    } else {
      //页面登录过期，跳转登录页面，携带query相关参数
      if (to.fullPath === '/login') {
        let bol = false;
        for (let i = 0; i < routerFiltration.length; ++i) {
          if (routerFiltration[i] === from.fullPath) {
            bol = true;
            break;
          }
        }

        //如果页面为注册或者修改密码页
        if (bol) {
          next()
        } else {
          next({
            path: '/login',
            query: { redirect: from.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
          });
        }

      } else {
        next()
      }
    }

    flag = false;
  }
  common.getLoginKey().then(res=>{
    sessionStorage.setItem('loginKey',res.obj.loginKey)
    routerSettings();
  })

});

// 跳转后返回顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})


export default router;
